import React, { useContext, useEffect, useState } from 'react'
import Loading from '../../../../components/Loading/Loading'
import ConfirmDialog from '../../../../components/ConfirmDialog/ConfirmDialog'
import { Doc_Counter, GetDocs } from '../../../../firebase/utils'
import { useNavigate } from 'react-router-dom'
import { DashboardContext } from '../../../../Hooks/DashboardContext'
import Banner from './Banner/Banner'
import Counter from '../../../../components/Counter/Counter'
import Pill from '../../../../components/Pill/Pill'
import Toggle from '../../../../components/Toggle/Toggle'



const BannerToggles = () => {
  const totalBanners = 15;
  const maxBannerNumber = 5;

  const [bannersChecked, setBannersChecked] = useState(Array(totalBanners).fill(false));

  const currentBannerNumber = bannersChecked.filter(Boolean).length;

  const handleBannerToggle = (index) => {
    setBannersChecked(prev => {
      const newBanners = [...prev];
      const currentlyChecked = newBanners[index];

      if (!currentlyChecked && currentBannerNumber >= maxBannerNumber) {
        return prev;
      }

      newBanners[index] = !currentlyChecked;
      return newBanners;
    });
  };

  return (
    <div>
      <p>{currentBannerNumber} / {maxBannerNumber} sélectionnées</p>
      {bannersChecked.map((isChecked, index) => (
        <button
          key={index}
          onClick={() => handleBannerToggle(index)}
          style={{
            backgroundColor: isChecked ? "green" : "gray",
            color: "white",
            padding: "10px",
            margin: "5px",
          }}
        >
          {isChecked ? "Checked" : "Unchecked"}
        </button>
      ))}
    </div>
  );
};


const Banners = () => {
  
    const [Banners,setBanners]=useState(null)
    const [BannersCount,setBannerCount]=useState(0)
    
    const {searchValue,MaxBannerNumber,setMaxBannerNumber}=useContext(DashboardContext)
    const [filteredItems,setfilteredItems]=useState(null)
    const navigate = useNavigate();

  

   
    function updateLimit() {
      return
      
    }
    
  
  
    useEffect(() => {
  
      document.querySelector('#Loading').showModal()
      GetDocs("Banners").then((result)=>setBanners(result))
      Doc_Counter ('Banners',setBannerCount)
     
    }, [])
  
    useEffect(
      ()=>{
        if (Banners===null) return
        document.querySelector('#Loading').close()
  
        setfilteredItems(Banners.filter(
          (banner)=>
          banner.Nom.toLowerCase().includes(searchValue.toLowerCase())
        ))
  
      },[searchValue,Banners])
    
   
  
  
    return (
      <div className='Products_container'>
       
      
        <div>
          <h1>
            Liste des Banners 
          </h1>
          
          <div  style={{width:'100%',padding:'2rem',display:'flex',alignItems:'center',justifyContent:'center',gap:'4rem'}}>
            <Counter maxValue={5} minValue={1} setMaxNumber={setMaxBannerNumber}/>
            <Pill bgcolor={'#333'} bordercolor={'transparent'} classe={'disabled'} color={'#777'} onclick={updateLimit} text={"mettre à jour la limite"} key={''}/>
              
           <div style={{display:'flex',alignItems:'center',gap:'0.5rem'}}>
            <span>Désactiver la visibilité sur le Homepage : </span>
             <Toggle/>
           </div>
          </div>


        </div>
        
        <div className='Products FadeIn'>
          
        {filteredItems!==null&&filteredItems.length<=0&&searchValue!==''?'Aucun produit ne correspond a la recherche':
  
          filteredItems===null? <Loading/> : filteredItems.map((banner,id)=>{ return (<Banner key={id} bannerDetails={banner}/>)}) 
       
  
        }
        {/*
        Array(7).fill(0).map((_,id)=>{return (<Banner key={id} bannerDetails={filteredItems[0]}/>)}) */}

        {
          /*<BannerToggles/>*/
        }

        

          <ConfirmDialog/>
  
          
        </div>
      </div>
    )
}

export default Banners